let idCounter = 1;
const cache: WeakMap<any, any> = new WeakMap();
export function generateKey(items: any) {
  const cached = cache.get(items);
  if (cached) return cached;
  const id = idCounter++;
  if (items) cache.set(items, id);
  return id;
}
